import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestRemoveEmailRecipient } from "./removeEmailRecipient.request";

const useRemoveEmailRecipient = (
  options?: MutationOptions<{ success: boolean }, ApiServiceError<ApiError>>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (recipientId: string) =>
      requestRemoveEmailRecipient(recipientId),
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({
        queryKey: ["email-notifications", "recipients"]
      });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useRemoveEmailRecipient;
